import { render } from "./ForceResetPsw.vue?vue&type=template&id=2c40d780&scoped=true"
import script from "./ForceResetPsw.vue?vue&type=script&lang=js"
export * from "./ForceResetPsw.vue?vue&type=script&lang=js"

import "./ForceResetPsw.vue?vue&type=style&index=0&id=2c40d780&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c40d780"],['__file',"src/views/Login/ForceResetPsw.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c40d780"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c40d780', __exports__)) {
    api.reload('2c40d780', __exports__)
  }
  
  module.hot.accept("./ForceResetPsw.vue?vue&type=template&id=2c40d780&scoped=true", () => {
    api.rerender('2c40d780', render)
  })

}


export default __exports__